<template style="width: 100%;">
	<div class="home">
		<!-- 小屏抽屉唤起按钮 -->
		<div v-if="isMobile" class="drawer-trigger" @click="showDrawer = true">
			<i class="el-icon-menu"></i>
		</div>

		<div class="layout-container" >
			<!-- 左侧区域 -->
			<div class="left-box" v-if="!isMobile">
				<template v-if="!isMobile">
					<div class="card user-info" style="top: 10px;">
						<h3>我的信息</h3>
						<p>姓名：{{ info.name }}</p>
						<p>学校：{{ schoolName }}</p>
						<p>班级：{{ forGradeNmae(info.gradeId) }} {{ info.classAlias }}</p>
					</div>
					<div class="card history" style="max-height: calc(100vh - 210px);">
						<div class="card-header">
							<h3>已结束</h3>
							<div class="count-tag">
								<i class="el-icon-s-grid"></i>
								<span>{{ forTotal }}</span>
							</div>
						</div>
						<div class="card-wrapper" style="height: 100%;overflow-y: auto;" ref="historyScrollWrap" @scroll="handleHistoryScroll">
							<div v-for="item in forClassList" :key="item.id" :class="['card-item', courseSubjectClass(item)]" @click="toClass(item)">
								<div v-if="courseSubjectLabel(item)" class="subject-pill">{{ courseSubjectLabel(item) }}</div>
								<div class="card-title" :title="item.courseName">{{ item.courseName }}</div>
								<div class="card-info">
									<div class="itemtitle">
										<span class="label">教 师:</span>
										<span class="infoname" :title="item.teacherName">{{ item.teacherName || '未知老师' }}</span>
									</div>
									<div class="itemtitle">
										<span class="label">学 科:</span>
										<span class="infoname" :title="item.subject">{{ item.subject || '--' }}</span>
									</div>
									<div class="itemtitle">
										<span class="label">时 间:</span>
										<span class="infoname">{{ formatTime(item.createTime) }}</span>
									</div>
								</div>
								<div class="time-row">
									<span></span>
									<div class="card-action">
										<span class="look-txt">点击查看记录</span>
									</div>
								</div>
							</div>
							<div v-if="forClassList.length === 0 && !historyLoading" class="empty-tip">暂无历史课堂</div>
							<div v-if="historyLoading" class="loading-tip"><i class="el-icon-loading"></i> 加载中...</div>
							<div v-if="historyNoMore && forClassList.length > 0" class="nomore-tip">没有更多数据了</div>
						</div>
					</div>
				</template>
			</div>

			<div class="right-box">
				<div class="card join-class">
					<div class="card-header">
						<h3>进行中</h3>
						<div class="count-tag">
							<i class="el-icon-s-grid"></i>
							<span>{{ total }}</span>
						</div>
					</div>
					<div class="card-wrapper" ref="joinScrollWrap" @scroll="handleJoinScroll" style="height: 100vh;">
						<div v-for="item in classList" :key="item.id" :class="['card-item', courseSubjectClass(item)]">
							<div v-if="courseSubjectLabel(item)" class="subject-pill">{{ courseSubjectLabel(item) }}</div>
							<div class="card-title" :title="item.courseName">{{ item.courseName }}</div>
							<div class="card-info">
								<div class="itemtitle">
									<span class="label">教 师:</span>
									<span class="infoname" :title="item.teacherName">{{ item.teacherName || '未知老师' }}</span>
								</div>
								<div class="itemtitle">
									<span class="label">学 科:</span>
									<span class="infoname" :title="item.subject">{{ item.subject || '--' }}</span>
								</div>
								<div class="itemtitle">
									<span class="label">时 间:</span>
									<span class="infoname" >{{ formatTime(item.createTime)}}</span>
								</div>
							</div>
							<div class="time-row">
								<span></span>
								<div class="card-action">
									<button class="enter-btn" @click="postStudentEnter(item)">进入课堂</button>
								</div>
							</div>
						</div>
						<div v-if="classList.length === 0 && !joinLoading" class="empty-tip">暂无可加入的课堂</div>
						<div v-if="joinLoading" class="loading-tip"><i class="el-icon-loading"></i> 加载中...</div>
						<div v-if="joinNoMore && classList.length > 0" class="nomore-tip">没有更多数据了</div>
					</div>
				</div>
			</div>
		</div>

		<!-- 移动端抽屉遮罩 点击外部关闭 -->
		<div v-if="isMobile && showDrawer" class="drawer-mask" @click="showDrawer = false"></div>
		<!-- 左侧抽屉：仅存放个人信息 + 历史课堂 -->
		<div v-if="isMobile" class="mobile-drawer" :class="{ active: showDrawer }">
			<div class="drawer-head">
				<h3>个人与历史课堂</h3>
				<i class="el-icon-close close-icon" @click="showDrawer = false"></i>
			</div>
			<div class="drawer-content">
				<div class="card user-info" >
					<h3>我的信息</h3>
					<p>姓名：{{ info.name }}</p>
					<p>学校：{{ schoolName }}</p>
					<p>班级：{{ forGradeNmae(info.gradeId) }} {{ info.classAlias }}</p>
				</div>
				<div class="card history">
					<div class="card-header">
						<h3>已结束</h3>
						<div class="count-tag">
							<i class="el-icon-s-grid"></i>
							<span>{{ forTotal }}</span>
						</div>
					</div>
					<div class="card-wrapper" ref="historyScrollWrapMobile" @scroll="handleHistoryScroll">
						<div v-for="item in forClassList" :key="item.id" :class="['card-item', courseSubjectClass(item)]" @click="toClass(item); showDrawer = false">
							<div v-if="courseSubjectLabel(item)" class="subject-pill">{{ courseSubjectLabel(item) }}</div>
							<div class="card-title" :title="item.courseName">{{ item.courseName }}</div>
							<div class="card-info">
								<div class="itemtitle">
									<span class="label">教 师:</span>
									<span class="infoname" :title="item.teacherName">{{ item.teacherName || '未知老师' }}</span>
								</div>
								<div class="itemtitle">
									<span class="label">学 科:</span>
									<span class="infoname" :title="item.subject">{{ item.subject || '--' }}</span>
								</div>
								<div class="itemtitle">
									<span class="label">时 间:</span>
									<span class="infoname">{{ formatTime(item.createTime) }}</span>
								</div>
							</div>
							<div class="time-row">
								<span></span>
								<div class="card-action">
									<span class="look-txt">点击查看记录</span>
								</div>
							</div>
						</div>
						<div v-if="forClassList.length === 0 && !historyLoading" class="empty-tip">暂无历史课堂</div>
						<div v-if="historyLoading" class="loading-tip"><i class="el-icon-loading"></i> 加载中...</div>
						<div v-if="historyNoMore && forClassList.length > 0" class="nomore-tip">没有更多数据了</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
export default {
	data() {
		return {
			info: {},
			schoolId: localStorage.getItem('orgId'),
			classList: [],
			studentId: localStorage.getItem('userId'),
			studentName: localStorage.getItem('nickName'),
			schoolName: localStorage.getItem('orgName'),
			forClassList: [],
			forTotal: 0,
			total: 0,
			login: null,
			pageSize: 10,
			requestCount: 0,

			pageNum: 1,
			joinLoading: false,
			joinNoMore: false,

			forPageNum: 1,
			historyLoading: false,
			historyNoMore: false,

			// 抽屉、屏幕判断
			isMobile: false,
			showDrawer: false
		}
	},
	mounted() {
		this.checkScreen()
		window.addEventListener('resize', this.checkScreen)
	},
	beforeDestroy() {
		window.removeEventListener('resize', this.checkScreen)
	},
	created() {
		this.login = null
		this.loginOpen('数据查询中...')
		this.getUserInfo()
		this.resetJoinLoad()
		this.resetHistoryLoad()
	},
	methods: {
		courseSubjectLabel(item = {}) {
			const text = item.subjectName || item.subject || item.subjectLabel || ''
			return text ? String(text).trim() : ''
		},
		courseSubjectClass(item = {}) {
			const text = `${this.courseSubjectLabel(item)} ${item.courseName || ''}`
			if (/英语|英文|English|单词|口语|听力|字母/i.test(text)) return 'subject-english'
			if (/语文|國文|作文|阅读|朗读|诗词|古诗/.test(text)) return 'subject-chinese'
			if (/数学|算术|几何|代数|口算|π|函数/.test(text)) return 'subject-math'
			if (/科学|物理|化学|生物|实验|自然|科学课|stem/i.test(text)) return 'subject-science'
			if (/美术|艺术|绘画|书法/.test(text)) return 'subject-art'
			if (/音乐|声乐|合唱|乐理/.test(text)) return 'subject-music'
			if (/体育|运动|体能|足球|篮球|跑步/.test(text)) return 'subject-pe'
			return 'subject-default'
		},
		// 判断是否小屏
		checkScreen() {
			this.isMobile = window.innerWidth < 768
			if (!this.isMobile) this.showDrawer = false
		},
		formatTime(timestamp) {
			if (!timestamp) return ''
			const date = new Date(timestamp)
			const y = date.getFullYear()
			const m = String(date.getMonth() + 1).padStart(2, '0')
			const d = String(date.getDate()).padStart(2, '0')
			const h = String(date.getHours()).padStart(2, '0')
			const min = String(date.getMinutes()).padStart(2, '0')
			return `${y}-${m}-${d} ${h}:${min}`
		},
		forGradeNmae(id) {
			var gradeList = ['请选择', '一', '二', '三', '四', '五', '六', '七', '八', '九', '高一', '高二', '高三']
			if (!id || id < 1 || id > 12) return ''
			return gradeList[id] + '年级'
		},
		closeLoading() {
			this.requestCount--
			if (this.requestCount === 0 && this.login) {
				this.login.close()
				this.login = null
			}
		},
		getUserInfo() {
			this.requestCount++
			this.API.get(this.API.student.getStudentInfo, { id: this.studentId })
				.then(res => {
					this.info = res.data.data
					localStorage.setItem('studentInfo', JSON.stringify(this.info))
				}).catch(() => {
					localStorage.removeItem('studentInfo')
				}).finally(() => this.closeLoading())
		},
		toClass(row) {
			if (!row) return
			this.$router.push({
				path: '/student/historyClassroom',
				query: { courseClassId: row.id, courseName: row.courseName }
			})
		},

		// 可加入课堂加载
		resetJoinLoad() {
			this.pageNum = 1
			this.classList = []
			this.joinNoMore = false
			this.joinLoading = false
			this.getClassList(true)
		},
		handleJoinScroll() {
			const wrap = this.$refs.joinScrollWrap
			if (!wrap || this.joinLoading || this.joinNoMore) return
			const { scrollTop, clientHeight, scrollHeight } = wrap
			if (scrollTop + clientHeight + 100 >= scrollHeight) {
				this.pageNum++
				this.getClassList(false)
			}
		},
		async getClassList(isReset) {
			this.joinLoading = true
			try {
				const { data } = await this.API.post(this.API.school.getStudentClassList, {
					studentId: Number(this.studentId),
					schoolId: Number(this.schoolId),
					courseStatus: 1,
					pageNum: this.pageNum,
					pageSize: this.pageSize
				})
				const records = data.data.records || []
				this.total = data.data.total || 0
				if (isReset) this.classList = records
				else this.classList = [...this.classList, ...records]
				if (this.classList.length >= this.total) this.joinNoMore = true
				await this.$nextTick()
				const wrap = this.$refs.joinScrollWrap
				if (wrap.scrollHeight <= wrap.clientHeight && !this.joinNoMore) {
					this.pageNum++
					this.getClassList(false)
				}
			} catch (e) {
				console.error('获取课堂失败', e)
			} finally {
				this.joinLoading = false
			}
		},
		postStudentEnter(item) {
			let courseClassId = item.id
			this.loginOpen('进入课堂中...')
			this.API.post(this.API.school.postStudentEnter, {
				schoolId: Number(this.schoolId),
				studentId: Number(this.studentId),
				studentName: this.studentName,
				courseClassId: courseClassId
			}).then(() => {
				this.login.close()
				localStorage.setItem('courseClassId', courseClassId)
				localStorage.setItem('customPageId', item.customPageId)
				localStorage.setItem('courseId', item.courseId)
				this.$router.push({ path: '/student/class', query: { courseClassId } })
			}).catch(() => this.login.close())
		},

		// 历史课堂加载
		resetHistoryLoad() {
			this.forPageNum = 1
			this.forClassList = []
			this.historyNoMore = false
			this.historyLoading = false
			this.forClassLists(true)
		},
		handleHistoryScroll() {
			const wrap = this.$refs.historyScrollWrap || this.$refs.historyScrollWrapMobile
			if (!wrap || this.historyLoading || this.historyNoMore) return
			const { scrollTop, clientHeight, scrollHeight } = wrap
			if (scrollTop + clientHeight + 100 >= scrollHeight) {
				this.forPageNum++
				this.forClassLists(false)
			}
		},
		async forClassLists(isReset) {
			this.historyLoading = true
			try {
				const res = await this.API.post(this.API.school.getStudentClassList, {
					studentId: Number(this.studentId),
					schoolId: Number(this.schoolId),
					courseStatus: 2,
					pageNum: this.forPageNum,
					pageSize: this.pageSize
				})
				const records = res.data.data.records || []
				this.forTotal = res.data.data.total || 0
				if (isReset) this.forClassList = records
				else this.forClassList = [...this.forClassList, ...records]
				if (this.forClassList.length >= this.forTotal) this.historyNoMore = true
				await this.$nextTick()
				const wrap = this.$refs.historyScrollWrap || this.$refs.historyScrollWrapMobile
				if (wrap.scrollHeight <= wrap.clientHeight && !this.historyNoMore) {
					this.forPageNum++
					this.forClassLists(false)
				}
			} catch (e) {
			} finally {
				this.historyLoading = false
			}
		},

		loginOpen(text) {
			this.requestCount = 0
			this.login = this.$loading({
				lock: true,
				text: text,
				zIndex: 100001,
				spinner: 'el-icon-loading',
				background: 'rgba(0, 0, 0, 0.7)'
			});
		}
	}
}
</script>

<style scoped>
.home {
	width: 100vw;
	height: 100vh;
	overflow-y: hidden; /* 页面允许整体滚动 */
	padding: 4vw;
	box-sizing: border-box;
	background: #f5faff;
	position: relative;
}

/* 小屏菜单按钮 */
.drawer-trigger {
	position: fixed;
	top: 120px;
	left: 12px;
	width: 40px;
	height: 40px;
	background: #409eff;
	border-radius: 8px;
	z-index: 999;
	display: flex;
	align-items: center;
	justify-content: center;
	color: #fff;
	font-size: 20px;
}

.layout-container {
	display: flex;
	gap: 3vw;
	max-width: 100%;
	margin: 0 auto;
	flex-wrap: wrap;
	height: 100%;
	box-sizing: border-box;
}

.left-box {
	flex: 1;
	max-width: 350px;
	display: flex;
	flex-direction: column;
	gap: 3vw;
	height: 100%;
}
.right-box {
	flex: 2;
	display: flex;
	flex-direction: column;
	height: 100%;
}

.card {
	background: #ffffff;
	padding: 4vw;
	border-radius: 3vw;
	box-shadow: 0 1vw 2vw rgba(0, 0, 0, 0.05);
	display: flex;
	flex-direction: column;
	height: 100%;
	box-sizing: border-box;
}
.card-header {
	display: flex;
	align-items: center;
	gap: 12px;
	margin-bottom: 15px;
	flex-shrink: 0;
}
.count-tag {
	min-width: 40px;
	border-radius: 5px;
	background-color: #2b85e4;
	height: 20px;
	display: flex;
	align-items: center;
	justify-content: center;
	padding: 2px;
	color: #fff;
	font-size: 12px;
}
.count-tag i {
	line-height: 20px;
}
.count-tag span {
	margin-left: 5px;
	line-height: 20px;
}
.card h3 {
	font-size: 4.2vw;
	margin: 0;
	color: #000000;
	font-weight: 800;
}
.user-info {
	background: #aaaaff;
	position: relative;
	display: block;
	overflow: hidden;
	z-index: 1;
	flex-shrink: 0;
	height: auto;
}
.user-info h3 {
	color: #ffffff;
}
.user-info p {
	font-size: 3.8vw;
	margin: 2vw 0;
	color: #ffffff;
}

.card-wrapper {
	width: 100%;
	box-sizing: border-box;
	display: flex;
	flex-wrap: wrap;
	/* 1. 缩小行间距到和教师端一致 6px，列间距保持16px */
	row-gap: 6px;
	column-gap: 16px;
	overflow-y: auto;
	padding: 0 4px 10px 4px;
	flex: 1;
	/* 关键修复1：取消行拉伸，所有行紧贴顶部，不自动填充空白 */
	align-content: flex-start;
	/* 关键修复2：卡片顶部对齐，避免默认拉伸产生底部留白 */
	align-items: flex-start;
}
.card-item {
	flex: 0 0 240px;
	position: relative;
	overflow: hidden;
	background: linear-gradient(135deg, #ffffff 0%, #f8fbff 48%, #eef7ff 100%);
	border-radius: 10px;
	padding: 12px 18px;
	box-shadow: 0 10px 28px rgba(31, 65, 105, 0.08);
	border: 1px solid rgba(126, 154, 186, 0.16);
	min-height: 172px;
	display: flex;
	flex-direction: column;
	justify-content: flex-start;
	transition: transform .18s ease, box-shadow .18s ease, border-color .18s ease;
}
.card-item:hover {
	transform: translateY(-2px);
	box-shadow: 0 16px 36px rgba(31, 65, 105, 0.13);
	border-color: rgba(64, 158, 255, 0.26);
}
.card-item::before,
.card-item::after {
	position: absolute;
	pointer-events: none;
	z-index: 0;
}
.card-item::before {
	content: "";
	inset: 0;
	background: radial-gradient(circle at 88% 12%, rgba(255, 255, 255, .9), transparent 26%);
}
.card-item::after {
	content: "AI";
	right: 14px;
	top: 12px;
	font-size: 38px;
	font-weight: 800;
	line-height: 1;
	color: rgba(64, 158, 255, .14);
}
.card-item>* {
	position: relative;
	z-index: 1;
}
.card-item:has(.infoname[title*="语文"]),
.card-item:has(.infoname[title*="作文"]),
.card-item:has(.infoname[title*="阅读"]),
.subject-chinese {
	background: linear-gradient(135deg, #ffffff 0%, #fff8fa 48%, #ffe8ee 100%);
}
.card-item:has(.infoname[title*="语文"])::after,
.card-item:has(.infoname[title*="作文"])::after,
.card-item:has(.infoname[title*="阅读"])::after,
.subject-chinese::after {
	content: "文";
	color: rgba(180, 71, 92, .15);
}
.card-item:has(.infoname[title*="数学"]),
.card-item:has(.infoname[title*="几何"]),
.card-item:has(.infoname[title*="口算"]),
.subject-math {
	background: linear-gradient(135deg, #ffffff 0%, #f7fbff 48%, #dff1ff 100%);
}
.card-item:has(.infoname[title*="数学"])::after,
.card-item:has(.infoname[title*="几何"])::after,
.card-item:has(.infoname[title*="口算"])::after,
.subject-math::after {
	content: "π";
	color: rgba(45, 117, 184, .16);
}
.card-item:has(.infoname[title*="英语"]),
.card-item:has(.infoname[title*="English"]),
.card-item:has(.infoname[title*="单词"]),
.subject-english {
	background: linear-gradient(135deg, #ffffff 0%, #f5fffb 48%, #ddf7ed 100%);
}
.card-item:has(.infoname[title*="英语"])::after,
.card-item:has(.infoname[title*="English"])::after,
.card-item:has(.infoname[title*="单词"])::after,
.subject-english::after {
	content: "A";
	color: rgba(27, 138, 114, .16);
}
.card-item:has(.infoname[title*="科学"]),
.card-item:has(.infoname[title*="实验"]),
.card-item:has(.infoname[title*="物理"]),
.card-item:has(.infoname[title*="化学"]),
.card-item:has(.infoname[title*="生物"]),
.subject-science {
	background: linear-gradient(135deg, #ffffff 0%, #faf9ff 48%, #eceaff 100%);
}
.card-item:has(.infoname[title*="科学"])::after,
.card-item:has(.infoname[title*="实验"])::after,
.card-item:has(.infoname[title*="物理"])::after,
.card-item:has(.infoname[title*="化学"])::after,
.card-item:has(.infoname[title*="生物"])::after,
.subject-science::after {
	content: "⚗";
	color: rgba(109, 91, 208, .16);
}
.subject-art {
	background: linear-gradient(135deg, #ffffff 0%, #fffaf4 48%, #ffefde 100%);
}
.subject-art::after {
	content: "艺";
	color: rgba(194, 96, 40, .16);
}
.subject-music {
	background: linear-gradient(135deg, #ffffff 0%, #fbf7ff 48%, #f4e8ff 100%);
}
.subject-music::after {
	content: "♪";
	color: rgba(140, 87, 184, .16);
}
.subject-pe {
	background: linear-gradient(135deg, #ffffff 0%, #f8fff6 48%, #e5f8e1 100%);
}
.subject-pe::after {
	content: "动";
	color: rgba(47, 138, 62, .16);
}
.subject-pill {
	align-self: flex-start;
	max-width: 100%;
	min-height: 20px;
	padding: 2px 8px;
	margin: -2px 0 7px;
	border-radius: 999px;
	background: rgba(255, 255, 255, 0.72);
	border: 1px solid rgba(64, 158, 255, .18);
	color: #2777d8;
	font-size: 11px;
	font-weight: 700;
	white-space: nowrap;
	overflow: hidden;
	text-overflow: ellipsis;
	box-shadow: 0 4px 12px rgba(31, 65, 105, 0.05);
}
/* 空/加载/无更多提示 */
.empty-tip,
.loading-tip,
.nomore-tip {
	width: 100%;
	text-align: center;
	padding: 40px 0;
	color: #999;
	font-size: 13px;
}
.card-title {
	font-size: 18px;
	font-weight: bold;
	margin-bottom: 10px;
	color: #409EFF;
	max-width: 100%;
	white-space: nowrap;
	overflow: hidden;
	text-overflow: ellipsis;
}
.card-info {
	font-size: 13px;
	color: #666;
	line-height: 1.6;
	margin-bottom: 8px;
	flex: 1;
}
.itemtitle {
	font-size: 14px;
	display: flex;
}
.label {
	width: 60px;
	padding-right: 8px;
	flex-shrink: 0;
	text-align-last: justify;
	display: inline-block;
}
.infoname {
	font-weight: 500;
	max-width: 220px;
	white-space: nowrap;
	overflow: hidden;
	text-overflow: ellipsis;
	display: inline-block;
}
.time-row {
	display: flex;
	justify-content: space-between;
	align-items: center;
	margin-top: auto;
	padding-top: 8px;
	border-top: 1px solid #f2f2f2;
	flex-shrink: 0;
}
.enter-btn {
	padding: 4px 12px;
	background: #07c160;
	color: #fff;
	border: none;
	border-radius: 6px;
	cursor: pointer;
}
.look-txt {
	color: #409eff;
	font-size: 13px;
	cursor: pointer;
}
.empty-tip,
.loading-tip,
.nomore-tip {
	grid-column: 1 / -1;
	text-align: center;
	padding: 40px 0;
	color: #999;
	font-size: 13px;
}
.card-wrapper::-webkit-scrollbar {
	width: 6px;
	height: 6px;
}
.card-wrapper::-webkit-scrollbar-thumb {
	border-radius: 3px;
	background: #cbd5e1;
}
.card-wrapper::-webkit-scrollbar-track {
	background: #f1f5f9;
	border-radius: 3px;
}

/* 抽屉遮罩 */
.drawer-mask {
	position: fixed;
	top: 0;
	left: 0;
	right: 0;
	bottom: 0;
	background: rgba(0,0,0,0.4);
	z-index: 998;
}
/* 抽屉容器 */
.mobile-drawer {
	position: fixed;
	top: 0;
	left: 0;
	bottom: 0;
	width: 80%;
	max-width: 360px;
	background: #f5faff;
	z-index: 999;
	transform: translateX(-100%);
	transition: transform 0.3s ease;
	display: flex;
	flex-direction: column;
}
.mobile-drawer.active {
	transform: translateX(0);
}
.drawer-head {
	display: flex;
	justify-content: space-between;
	align-items: center;
	padding: 16px 20px;
	background: #fff;
	border-bottom: 1px solid #eee;
	flex-shrink: 0;
}
.close-icon {
	font-size: 20px;
	cursor: pointer;
	color: #666;
}
.drawer-content {
	padding: 16px;
	overflow-y: auto; /* 抽屉内部滚动开启 */
	display: flex;
	flex-direction: column;
	gap: 20px;
	flex: 1; /* 占满抽屉剩余高度，超出滚动 */
}

@media (min-width: 768px) {
	.home {
		padding: 20px;
	}
	.layout-container {
		flex-wrap: nowrap;
		gap: 20px;
	}
	.card {
		padding: 20px;
		border-radius: 12px;
	}
	.card h3 {
		font-size: 18px;
	}
	.user-info p {
		font-size: 16px;
		margin: 8px 0;
	}
	.drawer-trigger {
		display: none;
	}
}
</style>
